var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRepeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 2H4C2.89543 2 2 2.89543 2 4V12C2 13.1046 2.89543 14 4 14H6V16H4C1.79086 16 0 14.2091 0 12V4C0 1.79086 1.79086 0 4 0H16C18.2091 0 20 1.79086 20 4V12C20 14.2091 18.2091 16 16 16H12.843L14.0141 17.1711C14.4401 17.5971 14.4401 18.2879 14.0141 18.7139C13.588 19.1399 12.8973 19.1399 12.4713 18.7139L9.35359 15.5962C9.15833 15.4009 9.15833 15.0843 9.35359 14.8891L12.4713 11.7714C12.8973 11.3454 13.588 11.3454 14.0141 11.7714C14.4401 12.1974 14.4401 12.8881 14.0141 13.3142L13.3282 14H16C17.1046 14 18 13.1046 18 12V4C18 2.89543 17.1046 2 16 2Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeat);
export default __webpack_public_path__ + "static/media/repeat.73b7707b2d1351f251ba788d8e7b8a45.svg";
export { ForwardRef as ReactComponent };